
 <template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Comprobantes de Pago"
          directory="Corrección solicitada"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
      <div class="col-12" v-if="evaluationList && evaluationList.length > 0">
        <app-note
          class="pt-2 clearfix"
          :title="$t('Procesos en bloque')"
          content-type="html"
          note-type="note-warning"
          :notes="[
            $t(
              'Se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
            ),
          ]"
        />
      </div>
      <br />
      <div class="col-12" v-if="evaluationList && evaluationList.length > 0">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in evaluationList" :key="key">
              <td class="align-middle">
                {{ value.accreditation_applications.record }}
              </td>
              <td class="align-middle">
                <br />
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle">{{ value.code }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-12">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          data-url="/treasury/deposits"
        >
          <div class="mb-primary" v-if="inputs.observations">
            <app-note
              style="text-transform: uppercase"
              class="pt-2 clearfix"
              title="Observación"
              content-type="html"
              note-type="note-warning"
              :notes="[$t(inputs.observations)]"
            />
          </div>
          <div class="form-group row align-items-center">
            <label class="col-sm-3 mb-0">Es Convenio</label>
            <app-input
              class="col-sm-9"
              type="radio-buttons"
              v-model="inputs.is_agreement"
              :list="confirm"
            />
          </div>
          <div class="row">
            <div class="col-12" v-if="!inputs.is_agreement">
              <legend>
                <p class="text-primary">Documentos anexados</p>
              </legend>
            </div>

            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th>FECHA DE CREACIÓN</th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="inputs.request_file">
                    <td class="align-middle">
                      <strong>Solicitud de Acreditación</strong>
                    </td>
                    <td class="align-middle">
                      {{ inputs.request_file.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <a
                        :href="inputs.request_file.full_url"
                        class="btn btn-success btn-md"
                        target="_blank"
                      >
                        <app-icon name="file"></app-icon> Ver
                      </a>
                    </td>
                  </tr>

                  <tr v-if="inputs.proforma">
                    <td class="align-middle">
                      <strong>Proforma</strong>
                    </td>
                    <td class="align-middle">
                      {{ inputs.proforma.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <a
                        :href="inputs.proforma.full_url"
                        class="btn btn-success btn-md"
                        target="_blank"
                      >
                        <app-icon name="file"></app-icon> Ver
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row" v-if="!inputs.is_agreement">
            <div class="col-md-12">
              <legend>
                <p class="text-primary">DATOS PARA FACTURACIÓN</p>
              </legend>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Razón Social</label>
                <app-input
                  type="text"
                  v-model="inputs.i_business_name"
                  :required="true"
                  :disabled="disabled"
                  placeholder="Ingrese el nombre o razón social"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>RUC</label>
                <app-input
                  type="number"
                  v-model="inputs.i_taxid"
                  :required="true"
                  :disabled="disabled"
                  placeholder="Ingrese el RUC"
                  @keyup="onChangeTaxid"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>País</label>
                <app-input
                  type="select"
                  v-model="inputs.i_country_id"
                  :list="[
                    { id: '', value: this.$t('select_option') },
                    ...this.$store.state.common.countries,
                  ]"
                  :required="true"
                  :disabled="disabled"
                />
              </div>
            </div>

            <div
              class="col-md-6"
              v-if="inputs.i_country_id && provinceList.length <= 1"
            >
              <div class="form-group">
                <label>Ciudad</label>
                <app-input
                  type="text"
                  v-model="inputs.i_city"
                  placeholder="Ingrese la ciudad"
                  :required="true"
                  :disabled="disabled"
                />
              </div>
            </div>

            <div class="col-md-6" v-if="provinceList.length > 1">
              <div class="form-group">
                <label>Provincia</label>
                <app-input
                  type="select"
                  v-model="inputs.i_province_id"
                  :list="[
                    { id: '', value: this.$t('select_option') },
                    ...provinceList,
                  ]"
                  :required="true"
                  :disabled="disabled"
                />
              </div>
            </div>

            <div class="col-md-6" v-if="provinceList.length > 1">
              <div class="form-group">
                <label>Ciudad</label>
                <app-input
                  type="select"
                  v-model="inputs.i_canton_id"
                  :list="[
                    { id: '', value: this.$t('select_option') },
                    ...cantonList,
                  ]"
                  :required="true"
                  :disabled="disabled"
                  placeholder="Ingrese la ciudad"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>E-mail</label>
                <app-input
                  type="email"
                  v-model="inputs.i_email"
                  placeholder="Ingrese su email"
                  :required="true"
                  :disabled="disabled"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Teléfono</label>
                <app-input
                  type="tel-input"
                  v-model="inputs.i_phone"
                  :required="true"
                  :disabled="disabled"
                  placeholder="Ingrese el teléfono"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Dirección</label>
                <app-input
                  type="textarea"
                  v-model="inputs.i_address"
                  :required="true"
                  :disabled="disabled"
                  placeholder="Ingrese la dirección"
                />
              </div>
            </div>
          </div>

          <div v-if="acc.delegate_name">
            <div class="row">
              <legend class="col-12 col-form-label text-primary pt-0 my-3">
                <h5>DATOS PERSONA RESPONSABLE DE LA ACREDITACIÓN (CONTACTO)</h5>
              </legend>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Nombre</label>
                  <app-input
                    type="text"
                    v-model="acc.delegate_name"
                    disabled
                    placeholder="Ingrese el nombre"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Cargo</label>
                  <app-input
                    type="text"
                    v-model="acc.delegate_position"
                    disabled
                    placeholder="Ingrese el RUC"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>E-mail</label>
                  <app-input
                    type="email"
                    v-model="acc.delegate_email"
                    placeholder="Ingrese su email"
                    disabled
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Teléfono</label>
                  <app-input
                    type="tel-input"
                    v-model="acc.delegate_phone"
                    disabled
                    placeholder="Ingrese el teléfono"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Celular</label>
                  <app-input
                    type="tel-input"
                    v-model="acc.delegate_cell"
                    disabled
                    placeholder="Ingrese el teléfono"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="!inputs.is_agreement">
            <div class="col-md-12">
              <legend>
                <p class="text-primary">Datos del pago</p>
              </legend>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Banco</label>
                <app-input
                  id="inpbank_id"
                  type="select"
                  v-on:change="handleBlur"
                  v-model="inputs.bank_id"
                  :list="bankList"
                  :required="true"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Tipo de transacción</label>
                <app-input
                  id="inpbank_id"
                  type="select"
                  v-model="inputs.transaction_type_id"
                  :list="transactionTypeList"
                  :required="true"
                />
              </div>
            </div>
          </div>

          <div class="mb-primary" v-if="!inputs.is_agreement">
            <app-note
              class="pt-2 clearfix"
              title="Nota"
              content-type="html"
              note-type="note-warning"
              :notes="[
                $t(
                  'SE ACEPTARAN ÚNICAMENTE PAGOS EN EFECTIVO (INCLUYE USO DE CHEQUES CERTIFICADOS O DE GERENCIA) Y CON TRANSFERENCIA. EL PAGO DEBE REALIZARSE POR EL VALOR TOTAL Y EXACTO DEL COMPROBANTE.'
                ),
              ]"
            />
          </div>

          <div class="row" v-if="!inputs.is_agreement">
            <div class="col-md-6">
              <div class="form-group">
                <label>Número de transacción</label>
                <app-input
                  id="inputs_name"
                  type="text"
                  @blur="handleBlur"
                  v-model="inputs.number"
                  :required="true"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Valor</label>
                <app-input
                  id="inputs_name"
                  type="number"
                  v-model="inputs.amount"
                  :required="true"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Fecha</label>
                <app-input
                  id="inputs_name"
                  type="date"
                  v-model="inputs.date"
                  :required="true"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label
                  ><h5 class="card-title m-0">
                    {{
                      inputs.is_agreement ? "Convenio" : "Comprobante de Pago"
                    }}
                  </h5></label
                >
                <app-input
                  type="file"
                  :label="
                    inputs.attach_deposit
                      ? inputs.attach_deposit.name
                      : $t('upload_your_file')
                  "
                  v-model="inputs.attach_deposit"
                  :required="true"
                  v-if="!inputs.file"
                />
                <div class="mt-2">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTb(inputs.file)"
                    v-if="inputs.file"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="deleteAttach()"
                    v-if="inputs.file"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div>
            <br />

            <div
              class="col-12"
              v-if="eval_annexes_files && eval_annexes_files.length > 0"
            >
              <legend v-if="!inputs.is_agreement">
                <p class="text-primary">
                  Pagos de honorarios de personal externo
                </p>
              </legend>
              <table
                class="table table-sm table-striped"
                v-if="!inputs.is_agreement"
              >
                <thead>
                  <tr>
                    <th scope="col">NOMBRE</th>
                    <th>FECHA DE CREACIÓN</th>
                    <th scope="col" class="text-center" style="width: 10%">
                      ACCIÓN
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, c) in eval_annexes_files" :key="c + 1">
                    <td class="align-middle">{{ item.filename }}</td>
                    <td class="align-middle">
                      {{ item.created_at | dateFormat }}
                    </td>
                    <td class="align-middle text-center">
                      <a
                        :href="item.annexed.full_url"
                        class="btn btn-success btn-md"
                        target="_blank"
                      >
                        <app-icon name="file"></app-icon> Ver
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <button type="submit" class="btn btn-primary" @click.prevent="submit">
            Guardar
          </button> -->
        </form>
      </div>

      <div class="col-12" :class="{ 'loading-opacity': preloader }">
        <br />

        <button type="submit" class="btn btn-primary" @click.prevent="submit">
          Guardar
        </button>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../../apiUrl";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";

export default {
  name: "CorrectionModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    depositId: String,
  },

  watch: {
    "inputs.i_country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.i_country_id
      );
    },

    "inputs.i_province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.i_province_id
      );
    },

    "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
          this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
          this.inputs.org.i_province_id
        );
      }
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  computed: {
    disabled() {
      return false;
    },
  },
  data() {
    return {
      preloader: false,
      deleteModal: false,
      showAnnexes: false,
      inputs: {
        is_agreement: 0,
        date: new Date(),
      },
      msgNumber: "",
      depositFile: "Seleccionar Archivo",
      feeFile: "Seleccionar Archivo",
      modalId: "correction-add-edit-modal",
      modalTitle: this.$t("add"),
      fee: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      provinceList: [],
      cantonList: [],
      bankList: [],
      acc: "",
      evaluationList: "",
      eval_annexes_files: "",
      transactionTypeList: [],
      external_personal_payment_invoices: [],
      external_personal_payment_vouchers: [],
      tmp: {},
      delayTimer: null,
    };
  },
  created() {
    this.getPoliticalDivision();
    this.modalTitle = this.$t("Verificación de comprobante de pago");
    this.getInfo();
    this.dataInfo();
  },
  methods: {
    returnPage() {
      window.location.href = `/treasury/corrections`;
    },

    // Comprobantes y facturas
    addFileInvoice() {
      if (this.external_personal_payment_invoices.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.external_personal_payment_invoices.push({
        record_id: this.inputs.eval_test_id,
        filename: null,
        file: null,
      });
    },

    addFileVoucher() {
      if (this.external_personal_payment_vouchers.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.external_personal_payment_vouchers.push({
        record_id: this.inputs.eval_test_id,
        filename: null,
        file: null,
      });
    },

    openTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModalOther(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFileInvoice(j) {
      this.external_personal_payment_invoices =
        this.external_personal_payment_invoices.filter(
          (value, index) => index != j
        );
    },

    removeRowFileVoucher(j) {
      this.external_personal_payment_vouchers =
        this.external_personal_payment_vouchers.filter(
          (value, index) => index != j
        );
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChangeInvoice(e, j) {
      const tmp = this.external_personal_payment_invoices[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.external_personal_payment_invoices[j], "file", null);
        this.$set(this.external_personal_payment_invoices[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }

      if (!tmp.filename)
        this.$set(
          this.external_personal_payment_invoices[j],
          "filename",
          e.target.files[0].name
        );
      this.chargeFile(j);
    },

    onChangeVoucher(e, j) {
      const tmp = this.external_personal_payment_vouchers[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.external_personal_payment_vouchers[j], "file", null);
        this.$set(this.external_personal_payment_vouchers[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename)
        this.$set(
          this.external_personal_payment_vouchers[j],
          "filename",
          e.target.files[0].name
        );
      this.chargeFileVoucher(j);
    },

    onKeyUpInvoice(j) {
      const tmp = this.external_personal_payment_invoices[j];
      if (!tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
    },

    onKeyUpVoucher(j) {
      const tmp = this.external_personal_payment_vouchers[j];
      if (!tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFileVoucher(j), 1000);
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `${actions.ACCREDITATION_PROCESS}/addFileInvoice`;
      const tmpo = this.external_personal_payment_invoices[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.external_personal_payment_invoices[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.external_personal_payment_invoices];
            tmp[j] = data;
            this.external_personal_payment_invoices = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    confirmed() {
      const url = `${actions.ACCREDITATION_PROCESS}/destroyFile?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (this.tmp.vj.type == "external_personal_payment_vouchers") {
            const tmp = this.external_personal_payment_vouchers.filter(
              (value, index) => index != this.tmp.j
            );
            this.external_personal_payment_vouchers = tmp;
            this.tmp = {};
          }
          if (this.tmp.vj.type == "external_personal_payment_invoices") {
            const tmp = this.external_personal_payment_invoices.filter(
              (value, index) => index != this.tmp.j
            );
            this.external_personal_payment_invoices = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    chargeFileVoucher(j) {
      this.deleteLoader = true;
      const url = `${actions.ACCREDITATION_PROCESS}/addFileVoucher`;
      const tmpo = this.external_personal_payment_vouchers[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.external_personal_payment_vouchers[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.external_personal_payment_vouchers];
            tmp[j] = data;
            this.external_personal_payment_vouchers = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    // Fin comprobantes y facturas
    openTb(item) {
      const w = window.open(item.path, "_blank");
      w.focus();
    },

    deleteAttach() {
      this.inputs.file = null;
      this.inputs.attached_file = null;
      this.inputs.delete_file = 0;
    },

    onKeyUp() {
      if (this.inputs.bank_id != null && this.inputs.number != null) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeck, 1000);
      } else {
        this.msgNumber = null;
      }
    },

    ckeck() {
      this.msgNumber = "";
      clearTimeout(this.delayTimer);
      const url = `treasury/deposits/validateDeposit/${this.inputs.number}/${this.inputs.bank_id}`;
      this.axiosGet(url).then((response) => {
        if (response.status == 200) {
          const { validate } = response.data;
          if (validate) {
            this.msgNumber = "Comprobante valido";
            this.classes = "text-success";
          } else {
            this.msgNumber = "Comprobante registrado";
            this.classes = "text-danger";
          }
        }
      });
    },

    dateToString(date) {
      return date != null ? moment(date).format("YYYY-MM-DD") : null;
    },

    onChangeTaxid() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => {
        if (!this.inputs.i_taxid || this.inputs.i_taxid.length != 13) {
          this.$toastr.e("El campo RUC es obligatorio y debe tener 13 digitos");
          return;
        }
        this.validateTaxid(this.inputs.i_taxid);
      }, 1000);
    },
    validateTaxid(taxid) {
      this.preloader = true;
      let url = `/register/users/validateRucPayment/${taxid}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.$toastr.e(response.data.message);
            }

            this.i_taxid = response.data.validate;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    getPoliticalDivision() {
      this.$store.dispatch("getPoliticalDivision");
    },

    dataInfo() {
      this.preloader = true;
      let url = `${actions.ACCREDITATION_PROCESS}/options`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.bankList = [
              { id: "", value: "Seleccione Banco" },
              ...response.data.bank,
            ];
            this.transactionTypeList = [
              { id: "", value: "Seleccione Transacción" },
              ...response.data.transactiontype,
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getInfo() {
      this.preloader = true;
      let url = `${actions.TREASURY_CORRECTIONS}/showData/${this.depositId}`;
      this.axiosGet(url)
        .then((response) => {
          this.inputs = response.data;
          this.inputs.date = new Date(response.data.date);
          this.acc = response.data.accreditation_application;
          if (response.data.eval_test) {
            this.eval_annexes_files =
              response.data.eval_test.eval_annexes_files;
          }

          if (
            response.data.evaluationList &&
            response.data.evaluationList.length > 0
          ) {
            this.evaluationList = response.data.evaluationList;
          }

          if (response.data.accreditation_application.request_signed) {
            this.inputs.request_file =
              response.data.accreditation_application.request_signed;
          } else {
            this.inputs.request_file = null;
          }

          if (response.data.eval_test.proforma) {
            this.inputs.proforma = response.data.eval_test.proforma;
          } else {
            this.inputs.proforma = null;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    handleBlur(e) {
      if (this.inputs.number && this.inputs.bank_id) {
        this.preloader = true;
        let number = this.inputs.number;
        let url = `${actions.TREASURY}/validateDeposit/${this.inputs.number}/${this.inputs.bank_id}`;
        this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              if (!response.data.validate) {
                this.inputs.number = null;
                this.msgNumber =
                  "Comprobante " + number + " ya esta registrado";
              } else {
                this.msgNumber = "";
              }
            }
          })
          .catch(({ error }) => {
            console.log(error);
          })
          .finally(() => {
            this.preloader = false;
          });
      }
    },
    fileChoosen(event) {
      if (event.target.files[0].type === "application/pdf") {
        if (event.target.files[0].size < 4111775) {
          this.depositFile = event.target.files[0].name;
        } else {
          this.$toastr.e("EL archivo PDF no debe exceder los 2MB.");
        }
      } else {
        this.$toastr.e("Solo permitidos archivos .pdf");
      }
    },
    fileChoosenFee(event) {
      if (event.target.files[0].size < 8111775) {
        this.feeFile = event.target.files[0].name;
      } else {
        this.$toastr.e("El archivo no debe exceder los 8MB.");
      }
    },
    submit() {
      this.inputs.id = this.depositId;
      const tmp = { ...this.inputs };
      if (tmp.date) {
        const d = tmp.date;
        tmp.date = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }
      let formData = new FormData();
      for (const [key, value] of Object.entries(tmp)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess() {
      this.$toastr.s("Su solicitud ha sido enviada a revisión.");
      this.returnPage();
    },
    afterSuccessFromGetEditData(response) {
      this.preloader = false;
    },

    cancelled() {
      this.deleteModal = false;
    },
  },
};
</script>